import styled from "styled-components";
import colors from "../../../../../../../../../../../../../styles/colorPalette";
import { fadeIn } from "../../../../../../../../../../../../../styles/animations";

export const Circle = styled.div`
  background: red;
  position: relative;
  border: 2px solid ${colors.white1};
  border-radius: 50%;
  min-width: 10px;
  min-height: 10px;
  margin-left: auto;
  margin-bottom: 13px;
  animation: 1s ${fadeIn} forwards;
  transition: all 0.8s;
`;
